'use strict';

angular.module('TurneroApp').service('personaJuridicaService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/PersonaJuridica/:id', {id: '@Id_PersonaJuridica'}, {
        Get_Empresas_Combo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/PersonaJuridica/Get_Empresas_Combo'
        },
        Get_Municipios_Combo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/PersonaJuridica/Get_Municipios_Combo'
        }
    });
}]);


// WEBPACK FOOTER //
// ./app/components/general/personaJuridicaService.js